export const RACE_INSURANCE_VERSION = "2026-09-05";
export const MAX_INSURANCE_CERTIFICATE_BYTES = 10 * 1024 * 1024;

export type RaceInsuranceCertificate = {
  storagePath: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
};

export type RaceInsuranceInput = {
  coverageConfirmed: boolean;
  platformDisclaimerAccepted: boolean;
  version: string;
  certificate: RaceInsuranceCertificate | null;
};

export type RaceInsuranceAcceptance = {
  coverageConfirmed: boolean;
  platformDisclaimerAccepted: boolean;
  version: string | null;
  acceptedBy: string | null;
  acceptedAt: Date | null;
};

export type RaceInsuranceCertificateRecord = {
  raceId: string;
  organizerUid: string;
  certificate: RaceInsuranceCertificate | null;
};

export const hasAcceptedRaceInsurance = (race: {
  organizerUid: string | null;
  insurance?: RaceInsuranceAcceptance | null;
}): boolean => {
  const insurance = race.insurance;
  return Boolean(
    insurance?.coverageConfirmed === true &&
      insurance.platformDisclaimerAccepted === true &&
      insurance.version === RACE_INSURANCE_VERSION &&
      race.organizerUid &&
      insurance.acceptedBy === race.organizerUid &&
      insurance.acceptedAt &&
      Number.isFinite(insurance.acceptedAt.getTime())
  );
};

export const getInsuranceCertificateError = (file: File): string | null => {
  if (file.size <= 0 || !["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
    return "Choose a PDF, JPG or PNG certificate.";
  }
  if (file.size > MAX_INSURANCE_CERTIFICATE_BYTES) {
    return "The insurance certificate must be 10 MB or smaller.";
  }
  return null;
};
